
import Vue from 'vue';
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./rootState";
import { registerMediators } from './mediators';
import { ConfigurationModule } from './modules/configuration';

Vue.use(Vuex);

const storeOptions: StoreOptions<RootState> = {
  modules: {
    ConfigurationModule,
  },
};

const store = new Vuex.Store(storeOptions);

registerMediators(store);

export default store;
